import { useState } from "react";
import { ArrowRight, LockKeyhole } from "lucide-react";
import { SITE } from "../../content";
import { Btn, Eyebrow, Reveal } from "./Primitives";

const TABS = [
  { id: "kinder", label: "Kinder", url: SITE.bookingUrl },
  { id: "erwachsene", label: "Erwachsene & Kraul", url: SITE.adultBookingUrl },
  { id: "privat", label: "Privatstunden", url: SITE.privateBookingUrl },
];

export const Booking = () => {
  const [tab, setTab] = useState("kinder");
  const active = TABS.find((t) => t.id === tab);
  return (
  <section id="buchung" data-testid="booking-section" className="relative isolate overflow-hidden bg-navy py-24 text-white sm:py-32">
    <img src="/images/under1.webp" alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 -z-10 h-full w-full object-cover opacity-25" />
    <div className="absolute inset-0 -z-10 bg-navy/70" />
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <div className="grid gap-12 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-8">
          <Eyebrow dark>Kursbuchung</Eyebrow>
          <h2 className="mt-6 text-4xl font-extrabold leading-[1.02] tracking-[-0.02em] sm:text-6xl lg:text-7xl">
            Bereit für den <span className="font-light italic text-sky-200">ersten Zug?</span>
          </h2>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-slate-200 md:text-lg">
            Wählen Sie den passenden Kurs und sichern Sie sich einen Platz – mit aktuellen Terminen, Preisen und freien Plätzen direkt hier.
          </p>
        </Reveal>
        <Reveal delay={0.15} className="flex flex-col gap-4 lg:col-span-4">
          <Btn href={active.url} testid="booking-main-btn" external>
            Buchung in neuem Fenster <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Btn>
          <a href={SITE.parentAppUrl} data-testid="booking-elternbereich-link" className="mt-2 inline-flex items-center justify-center gap-2 text-sm font-semibold text-sky-200 transition-colors hover:text-white">
            <LockKeyhole className="h-4 w-4" /> Bereits angemeldet? Zum App Login
          </a>
        </Reveal>
      </div>
      <Reveal delay={0.1} className="mt-14">
        <div role="tablist" aria-label="Kursart" className="mb-4 inline-flex max-w-full flex-wrap gap-1 rounded-3xl border border-white/20 p-1 sm:rounded-full">
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              role="tab"
              aria-selected={tab === t.id}
              onClick={() => setTab(t.id)}
              data-testid={`booking-tab-${t.id}`}
              className={`rounded-full px-5 py-2.5 text-sm font-bold transition-colors duration-300 ${tab === t.id ? "bg-white text-navy" : "text-white/85 hover:text-white"}`}
            >
              {t.label}
            </button>
          ))}
        </div>
        <div className="overflow-hidden bg-white p-2 shadow-[0_40px_80px_-40px_rgba(0,0,0,0.6)] sm:p-4">
          <iframe
            key={active.id}
            src={active.url}
            title={`Kursbuchung ${active.label} – Schwimmschule Manta (YOLAWO)`}
            loading="lazy"
            data-testid="booking-yolawo-embed"
            className="block h-[1000px] w-full border-0 sm:h-[820px] lg:h-[720px]"
          />
        </div>
      </Reveal>
    </div>
  </section>
  );
};
